var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_vm._v(" "+_vm._s(_vm.reservations.appointments)+" ")]),_c('div',[_c('h3',[_vm._v("trié")]),_c('p',[_vm._v(_vm._s(_vm.sortedAppointment))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }